export default __webpack_public_path__ + "static/media/logo-light.2f192a28.svg";